import { useLocation, useNavigate } from "react-router-dom";
import { useCookies } from "react-cookie";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRightFromBracket } from "@fortawesome/free-solid-svg-icons";
import cn from "classnames";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { clearAccessRightsList, clearAuthData } from "../../store/authSlice";
import { selectCurrentUserInfo } from "../../store/userSlice";
import useAccessRight from "../../hooks/useAccessRight";
import useTranslate from "../../hooks/useTranslate";
import { ACCESS_TOKEN, REFRESH_TOKEN } from "../../constants/cookieNames";
import { backgroundColor } from "../../constants/colors";
import { IDockPanelProps } from "./DockPanel.props";
import styles from "./DockPanel.module.scss";
import { LOGIN } from "@/constants/routes";
import { routes } from "./DockPanel.const";

const DockPanel = ({ setShowDockPanel, setShowPage }: IDockPanelProps): JSX.Element => {
	const dispatch = useAppDispatch();
	const currentUserInfo = useAppSelector(selectCurrentUserInfo); // store - информация о текущем пользователе

	const navigate = useNavigate(); // hook для навигации
	const location = useLocation(); // hook для определения адреса
	const [_, __, removeCookies] = useCookies([ACCESS_TOKEN, REFRESH_TOKEN]); // hook для работы с cookie
	const isAccess = useAccessRight(); // hook для проверки прав доступа
	const translate = useTranslate(); // hook для перевода текста

	// logout
	const logout = () => {
		setShowDockPanel(false); // скрываем dock-панель
		// после скрытия dock-панели уводим страницу в фон
		setTimeout(() => {
			setShowPage(false);

			setTimeout(() => {
				removeCookies(ACCESS_TOKEN, { path: "/" });
				removeCookies(REFRESH_TOKEN, { path: "/" });
				dispatch(clearAuthData());
				dispatch(clearAccessRightsList());
				// задержка для удаления cookie
				setTimeout(() => {
					navigate(LOGIN, { state: location.pathname });
				});
			}, 500); // после скрытия страницы переходим через 500мс
		}, 500);
	};

	// обработчик навигации
	const moveToHandler = (right: string | string[], route: string) => {
		// если есть право и путь не содержит роут для перехода
		if (isAccess(right) && !location.pathname.includes(route)) {
			setShowDockPanel(false); // скрываем dock-панель
			// после скрытия dock-панели уводим страницу в фон
			setTimeout(() => {
				setShowPage(false);
				setTimeout(() => {
					navigate(route);
				}, 500); // после скрытия страницы переходим через 500мс
			}, 500);
		}
	};

	return (
		<div className={styles.dockPanel} onClick={(e) => e.stopPropagation()}>
			{currentUserInfo.id ? (
				routes.map(({ accessOptions, mainRoute, name, img }) => {
					const firstAvailableOption = accessOptions.find(({ right }) => isAccess(right)); // совпадение по доступу
					return (
						<div
							className={cn(styles.dockPanelLink, {
								[styles.dockPanelLinkNonActive]: !firstAvailableOption, // недоступный сервис
								[styles.dockPanelLinkActive]: location.pathname.includes(mainRoute), // активный сервис
							})}
							onClick={() => firstAvailableOption && moveToHandler(firstAvailableOption.right, firstAvailableOption.route)}
							key={name}
						>
							<span className={styles.dockPanelTitle}>{translate(name)}</span>
							<img className={styles.dockPanelImg} src={img} alt={translate(name)} />
						</div>
					);
				})
			) : (
				<p>{translate(currentUserInfo.message || "title_failedAccessRights")}</p>
			)}

			<div className={styles.dockPanelLink} onClick={logout}>
				<span className={styles.dockPanelTitle}>{translate("button_exit")}</span>
				<div className={styles.dockPanelLogoutIcon}>
					<FontAwesomeIcon icon={faRightFromBracket} size="4x" color={backgroundColor} />
				</div>
			</div>
		</div>
	);
};

export default DockPanel;
